import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { Fragment } from "react";
import Robot from "../../assets/images/robot.png";
import SetServerUrl from "../../modules/URL";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& p": {
      color: theme.palette.common.black,
    },
    height: "65vh",
  },
  logo: {
    marginBottom: "1.5rem",
  },

  strong: {
    fontSize: ".987rem",
    fontWeight: "600",
  },
}));

const getPageSettingData = JSON.parse(localStorage.getItem("pageSettingData"));
const validData = (getPageSettingData || {}).getData;

const setData = {
  logo: (validData || "").logo,
};

const NotFound = () => {
  const pathName = window.location.pathname;
  const classes = useStyles();
  return (
    <Fragment>
      <Box className={classes.root}>
        <Box marginRight="2rem">
          <img
            className={classes.logo}
            src={`${setData.logo && SetServerUrl}${setData.logo}`}
            alt=""
          />
          <Typography variant="body1">
            <Typography className={classes.strong} component="strong">
              404.
            </Typography>
            <Typography component="span">That&apos;s an error.</Typography>
          </Typography>
          <Typography variant="body1">
            The requested URL {pathName} was not found on this server.
          </Typography>
          <Typography component="span">That’s all we know.</Typography>
        </Box>
        <Box marginLeft="2rem">
          <img src={Robot} alt="" />
        </Box>
      </Box>
    </Fragment>
  );
};

export default NotFound;
